module.exports = __webpack_public_path__ + "static/a-mathematicians-apology-d330a7665ed855d11ae84caabb5172c3.jpg";